module.exports = __webpack_public_path__ + "img/writers.346b0975.svg";